import { render, staticRenderFns } from "./ModalConfiguration.vue?vue&type=template&id=0d1e88b8&"
import script from "./ModalConfiguration.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports